<!-- eslint-disable -->
<template lang="pug">
    .multiplayer-game-menu__selectors
        cs-multiline-multiselect.selector.formula-selector(
            v-if="slug !== 'AdditionAndSubtractionMathMagic'"
            :options="formulas",
            :multiple="false",
            placeholder="",
            :selected-multiline-options="selectedMultilineOptions",
            :value="selectedFormula",
            :allow-empty="false",
            :disabled="gameState === 'started'"
        )
            ul.multiline-content(v-for="formula in formulas", :slot="`multiline-option-${formula.name}`")
                li.multiline-content__option(v-for="(multilevelOption, index) in formula.multilevelValues")
                    cs-checkbox(
                        :value="multilevelOption",
                        :checked="isMultilevelOptionSelected(multilevelOption, formula.name)",
                        @click.native.prevent.stop="setNumber(multilevelOption, formula.name)"
                        :disabled="isFormulaCheckboxesDisabled(multilevelOption, formula.name)"
                    ) {{ multilevelOption }}
        cs-multiselect.selector.examples-type-selector(
            v-if="slug !== 'AdditionAndSubtractionMathMagic'"
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            label="label",
            v-model="selectedExamplesType",
            :options="examplesTypes",
            :disabled="isExamplesTypesDisabled"
        )
        cs-multiselect.selector.difficulty-selecor(
            :multiple="false",
            :show-labels="false",
            label="value",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="selectedDifficulty",
            :options="difficulties",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameSetting_difficult') }}:
                |
        cs-multiselect.selector.actions-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="selectedAmountOfActions",
            :options="amountsOfActions",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameFormSetting_actions') }}:
                |
        cs-multiselect.selector.players-selector(
            :multiple="false",
            :show-labels="false",
            :searchable="false",
            :close-on-select="true",
            :allow-empty="false",
            v-model="playersAmount",
            :options="players",
            :disabled="gameState === 'started'"
        )
            span(slot="inner-label")
                | {{ $i18n.t('trainer.trainer_gameSetting_players') }}:
                |
        cs-spin-input.selector.speed-input(
            v-if="slug === 'AdditionAndSubtractionWithTime'"
            type="text",
            :value="`${selectedSpeed}с`",
            :max="`${seconds[seconds.length - 1]}с`",
            :min="`${seconds[0]}с`",
            @increase="increaseSpeed",
            @decrease="decreaseSpeed",
            :disabled="gameState === 'started'"
        )
</template>

<script>
    /*eslint-disable*/
    import MultiplayerOptionsMixin from '../../../utils/multiplayer/optionsMixin';
    import AddSubConfig from "../../trainer/configs/AddSubConfig";

    const SIMPLE = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    const BROTHERS = [4, 3, 2, 1];
    const FRIENDS = [9, 8, 7, 6, 5, 4, 3, 2, 1];
    const BROTHERS_AND_FRIENDS = [6, 7, 8, 9];
    const SIMPLE_KEY = 'simple';
    const BROTHERS_KEY = 'brothers';
    const FRIENDS_KEY = 'friends';
    const BROTHERS_AND_FRIENDS_KEY = 'brothersAndFriends';
    const FORMULAS_KEYS = [SIMPLE_KEY, BROTHERS_KEY, FRIENDS_KEY, BROTHERS_AND_FRIENDS_KEY];
    const EXAMPLES_TYPE_KEYS = ['friendsOptions', 'brothersOptions', 'brothersAndFriendsOptions'];
    const ADDITION = 'addition';
    const SUBTRACTION = 'subtraction';
    const ADDITION_AND_SUBTRACTION = 'additionAndSubtraction';
    const PLAYING_STATE = 'started';
    const COMMON_PARAMETERS_CHANGED_EVENT = 'commonParametersHasChanged';

    export default {
        mounted () {
            this.selectedDifficulty = this.difficulties.find(difficulty => this.commonParams.difficult === difficulty.name);
            this.selectedAmountOfActions = this.commonParams.amountOfActions;
            if (this.slug === 'AdditionAndSubtractionWithTime') {
                this.selectedSpeed = this.commonParams.speed;
                this.currentSpeedIndex = this.seconds.indexOf(this.selectedSpeed);
            }
            this.setDefaultValuesForFormulas();
            this.setDefaultValueForExamplesType();
        },
        mixins: [MultiplayerOptionsMixin],
        watch: {
            selectedFormula: {
                handler (value, oldValue) {
                    if (value) {
                        let neededKey = `${value.name}Options`;
                        if (this.commonParams[neededKey]) {
                            if (this.commonParams[neededKey].onlyAddition && !this.commonParams[neededKey].onlySubtraction) {
                                this.selectedExamplesType = this.examplesTypes.find(type => type.key === ADDITION);
                            } else if (!this.commonParams[neededKey].onlyAddition && this.commonParams[neededKey].onlySubtraction) {
                                this.selectedExamplesType = this.examplesTypes.find(type => type.key === SUBTRACTION);
                            } else if (!this.commonParams[neededKey].onlyAddition && !this.commonParams[neededKey].onlySubtraction) {
                                this.selectedExamplesType = this.examplesTypes.find(type => type.key === ADDITION_AND_SUBTRACTION);
                            }
                        }
                        // this.selectedExamplesType = this.examplesTypes.find(type => type.key === ADDITION_AND_SUBTRACTION);
                    }
                    if (oldValue !== null) {
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: value.name, value: this.commonParams[value.name]});
                    }
                },
                deep: true,
            },
            selectedExamplesType: {
                handler (value, oldValue) {
                    if (value && this.selectedFormula && this.selectedFormula.name !== SIMPLE_KEY) {
                        let neededKey = `${this.selectedFormula.name}Options`;
                        switch (value.key) {
                            case ADDITION: {
                                this.commonParams[neededKey].onlyAddition = true;
                                this.commonParams[neededKey].onlySubtraction = false;
                                break;
                            }
                            case SUBTRACTION: {
                                this.commonParams[neededKey].onlyAddition = false;
                                this.commonParams[neededKey].onlySubtraction = true;
                                break;
                            }
                            default: {
                                this.commonParams[neededKey].onlyAddition = false;
                                this.commonParams[neededKey].onlySubtraction = false;
                                break;
                            }
                        }
                        this.$emit(
                            COMMON_PARAMETERS_CHANGED_EVENT,
                            {
                                setOptionsValues: true,
                                name: neededKey,
                                subNames: ['onlyAddition', 'onlySubtraction'],
                                values: [
                                    this.commonParams[neededKey].onlyAddition,
                                    this.commonParams[neededKey].onlySubtraction
                                ]
                            }
                        );
                    }
                },
                deep: true,
            },
            areBrothersOnlyOptionsDisabled (val, oldVal) {
                if (val && oldVal !== null) {
                    this.commonParams.brothersOptions.onlyAddition = false;
                    this.commonParams.brothersOptions.onlySubtraction = false;
                    this.$emit(
                        COMMON_PARAMETERS_CHANGED_EVENT,
                        {
                            setOptionsValues: true,
                            name: 'brothersOptions',
                            subNames: ['onlyAddition', 'onlySubtraction'],
                            values: [false, false]
                        }
                    );
                }
            },
            areFriendsOnlyOptionsDisabled (val, oldVal) {
                if (val && oldVal !== null) {
                    this.commonParams.friendsOptions.onlyAddition = false;
                    this.commonParams.friendsOptions.onlySubtraction = false;
                    this.$emit(
                        COMMON_PARAMETERS_CHANGED_EVENT,
                        {
                            setOptionsValues: true,
                            name: 'friendsOptions',
                            subNames: ['onlyAddition', 'onlySubtraction'],
                            values: [false, false]
                        }
                    );
                }
            },
            areBrothersAndFriendsOnlyOptionsDisabled (val, oldVal) {
                if (val && oldVal !== null) {
                    this.commonParams.brothersAndFriendsOptions.onlyAddition = false;
                    this.commonParams.brothersAndFriendsOptions.onlySubtraction = false;
                    this.$emit(
                        COMMON_PARAMETERS_CHANGED_EVENT,
                        {
                            setOptionsValues: true,
                            name: 'brothersAndFriendsOptions',
                            subNames: ['onlyAddition', 'onlySubtraction'],
                            values: [false, false]
                        }
                    );
                }
            },
            selectedDifficulty: {
                handler (value, oldValue) {
                    if (oldValue !== null) {
                        this.commonParams.difficult = this.difficulties.find(difficult => difficult.value === value.value).name;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'difficult', value: this.commonParams.difficult});
                    }
                }
            },
            selectedAmountOfActions: {
                handler (value, oldValue) {
                    if (oldValue !== 0) {
                        this.commonParams.amountsOfActions = value;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'amountOfActions', value});
                    }
                }
            },
            selectedSpeed: {
                handler (value, oldValue) {
                    if (oldValue !== 0) {
                        this.commonParams.speed = value;
                        this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: 'speed', value});
                    }
                }
            },
        },
        data () {
            return {
                selectedFormula: null,
                selectedExamplesType: null,
                selectedDifficulty: null,
                selectedAmountOfActions: 0,
                formulas: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_simple'),
                        multilevelValues: SIMPLE,
                        name: SIMPLE_KEY
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_brothers'),
                        multilevelValues: BROTHERS,
                        name: BROTHERS_KEY
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_friends'),
                        multilevelValues: FRIENDS,
                        name: FRIENDS_KEY
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_brothersAndFriends'),
                        multilevelValues: BROTHERS_AND_FRIENDS,
                        name: BROTHERS_AND_FRIENDS_KEY
                    }
                ],
                examplesTypes: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameSetting_addition'),
                        key: ADDITION,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameSetting_subtraction'),
                        key: SUBTRACTION,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameSetting_additionAndSubtraction'),
                        key: ADDITION_AND_SUBTRACTION,
                    }
                ],
                selectedMultilineOptions: '',
                seconds: AddSubConfig.seconds,
                currentSpeedIndex: 0,
                selectedSpeed: 0,
            }
        },
        methods: {
            isMultilevelOptionSelected (number, type) {
                return this.commonParams && this.commonParams[type] && this.commonParams[type].includes(number);
            },
            setNumber (number, type) {
                if (type !== SIMPLE_KEY) {
                    this.commonParams.simple = SIMPLE;
                }
                if (this.commonParams[type].includes(number)) {
                    this.commonParams[type] = this.commonParams[type].filter(value => value !== number);
                } else {
                    this.commonParams[type].push(number);
                }
                this.selectedMultilineOptions = `(${this.commonParams[type].join(', ')})`;
                FORMULAS_KEYS.forEach(key => {
                    this.$emit(COMMON_PARAMETERS_CHANGED_EVENT, {name: key, value: this.commonParams[key]});
                });
                this.handleFormulaSelect(this.formulas.find(formula => formula.name === type));
            },
            handleFormulaSelect (option) {
                this.selectedFormula = option;
                if (this.commonParams && this.commonParams[this.selectedFormula.name] && this.commonParams[this.selectedFormula.name].length) {
                    this.selectedMultilineOptions = `(${this.commonParams[this.selectedFormula.name].join(', ')})`;
                } else {
                    this.selectedMultilineOptions = '';
                }
            },
            setDefaultValuesForFormulas () {
                if (this.commonParams) {
                    FORMULAS_KEYS.forEach(key => {
                        if (this.commonParams[key] && this.commonParams[key].length) {
                            this.selectedFormula = {
                                label: this.$i18n.t(`trainer.trainer_gameFormSetting_${key}`),
                                multilevelValues: this.commonParams[key],
                                name: key,
                            };
                            this.selectedMultilineOptions = `(${this.commonParams[key].join(', ')})`;
                        }
                    });
                }
            },
            setDefaultValueForExamplesType () {
                if (this.commonParams) {
                    for (let i = 0; i < EXAMPLES_TYPE_KEYS.length; i++) {
                        if (this.commonParams[EXAMPLES_TYPE_KEYS[i]] && this.commonParams[EXAMPLES_TYPE_KEYS[i]].onlyAddition) {
                            this.selectedExamplesType = this.examplesTypes.find(type => type.key === ADDITION);
                            return;
                        }
                        if (this.commonParams[EXAMPLES_TYPE_KEYS[i]] && this.commonParams[EXAMPLES_TYPE_KEYS[i]].onlySubtraction) {
                            this.selectedExamplesType = this.examplesTypes.find(type => type.key === SUBTRACTION);
                            return;
                        }
                        this.selectedExamplesType = this.examplesTypes.find(type => type.key === ADDITION_AND_SUBTRACTION);
                    }
                }
            },
            increaseSpeed () {
                this.currentSpeedIndex += 1;
                this.selectedSpeed = this.seconds[this.currentSpeedIndex];
            },
            decreaseSpeed () {
                this.currentSpeedIndex -= 1;
                this.selectedSpeed = this.seconds[this.currentSpeedIndex];
            },
            isSimpleDisabled (number) {
                return this.simpleDisabled
                        ||  this.commonParams && (
                                this.commonParams.simple.filter(value => value <= 2).length === 1
                                && number <= 2
                                && this.commonParams.simple.includes(number)
                        )
            },
            isOnlyJumpOverSetting (number, type) {
                const oppositeType = type === FRIENDS_KEY ? BROTHERS_AND_FRIENDS_KEY : FRIENDS_KEY;
                return  this.commonParams && (!!this.commonParams.jumpOver
                        && this.commonParams[type].includes(number)
                        && this.commonParams[type].length === 1
                        && !this.commonParams[oppositeType].length);
            },
            isFormulaCheckboxesDisabled (number, type) {
                return type && (
                        (type === SIMPLE_KEY && this.isSimpleDisabled(number))
                        || (type === BROTHERS_KEY && this.brothersDisabled)
                        || (type === FRIENDS_KEY && (this.isOnlyJumpOverSetting(number, type) || this.friendsDisabled))
                        || (type === BROTHERS_AND_FRIENDS_KEY && (this.isOnlyJumpOverSetting(number, type) || this.brothersAndFriendsDisabled))
                );
            },
        },
        computed: {
            difficulties() {
                let commonDifficult = [
                    {
                        label: this.$i18n.t('common.common_gameSetting_singleDigitNum'),
                        name: 'Однозначные цифры',
                        $isDisabled: false,
                        value: 1,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_doubleDigitsNum'),
                        name: 'Двузначные цифры',
                        $isDisabled: false,
                        value: 2,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_tripleDigitsNum'),
                        name: 'Трехзначные цифры',
                        $isDisabled: false,
                        value: 3,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fourDigitsNum'),
                        name: 'Четырехзначные цифры',
                        $isDisabled: false,
                        value: 4,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_fiveDigitsNum'),
                        name: 'Пятизначные цифры',
                        $isDisabled: false,
                        value: 5,
                    },
                ];
                let extraDifficult = [
                    {
                        label: this.$i18n.t('common.common_gameSetting_sixDigitsNum'),
                        name: 'Шестизначные цифры',
                        $isDisabled: false,
                        value: 6,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_sevenDigitsNum'),
                        name: 'Семизначные цифры',
                        $isDisabled: false,
                        value: 7,
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_eightDigitsNum'),
                        name: 'Восьмизначные цифры',
                        $isDisabled: false,
                        value: 8,
                    }
                ];
                if (this.slug === 'AdditionAndSubtractionMathMagic') {
                    return commonDifficult;
                }
                return [...commonDifficult, ...extraDifficult];
            },
            amountsOfActions () {
                let amount = this.slug === 'AdditionAndSubtractionWithTime' ? 101 : 16;
                return [...Array(amount).keys()].slice(2);
            },
            simpleDisabled () {
                return this.commonParams && (!!this.commonParams.brothers.length
                        || !!this.commonParams.friends.length
                        || !!this.commonParams.brothersAndFriends.length
                        || this.commonParams.negativeAnswers
                        || this.commonParams.interimAnswers);
            },
            brothersDisabled() {
                return  this.commonParams && (this.commonParams.negativeAnswers
                        || !!this.commonParams.interimAnswers
                        || !!this.commonParams.jumpOver);
            },
            friendsDisabled() {
                return  this.commonParams && !!this.commonParams.interimAnswers;
            },
            brothersAndFriendsDisabled() {
                return  this.commonParams && !!this.commonParams.interimAnswers;
            },
            areBrothersOnlyOptionsDisabled () {
                return this.commonParams && (!!this.commonParams.interimAnswers || !this.commonParams.brothers?.length);
            },
            areFriendsOnlyOptionsDisabled () {
                return this.commonParams
                    && (
                        this.commonParams.interimAnswers
                        || (
                            this.commonParams.negativeAnswers
                            && (!this.commonParams.brothersAndFriends?.length || this.commonParams.brothersAndFriendsOptions?.onlyAddition)
                        ) || !this.commonParams.friends?.length);
            },
            areBrothersAndFriendsOnlyOptionsDisabled () {
                return this.commonParams
                    && (
                        this.commonParams.interimAnswers
                        || (
                            this.commonParams.negativeAnswers
                            && (!this.commonParams.friends?.length || this.commonParams.friendsOptions?.onlyAddition)
                        ) || !this.commonParams.brothersAndFriends?.length);
            },
            isExamplesTypesDisabled () {
                return this.gameState === PLAYING_STATE
                    || this.selectedFormula && (
                        this.selectedFormula.name === SIMPLE_KEY
                        || (this.selectedFormula.name === BROTHERS_KEY && this.areBrothersOnlyOptionsDisabled)
                        || (this.selectedFormula.name === FRIENDS_KEY && this.areFriendsOnlyOptionsDisabled)
                        || (this.selectedFormula.name === BROTHERS_AND_FRIENDS_KEY && this.areBrothersAndFriendsOnlyOptionsDisabled)
                    );
            },
        }
    }
</script>

<style scoped lang="scss">
    .multiplayer-game-menu__selectors {
        display: flex;
        width: 80%;
        margin: 20px;
    }
    .selector {
        margin: 0 10px;
        max-height: 44px;
        &:first-child {
            margin-left: 0;
        }
        @media screen and (max-width: 1439px) {
            max-width: 150px;
        }
    }
    .formula-selector {
        width: 150% !important;
    }
</style>
